import { render, staticRenderFns } from "./ContentMatrix.vue?vue&type=template&id=1b658c5c"
import script from "./ContentMatrix.vue?vue&type=script&lang=js"
export * from "./ContentMatrix.vue?vue&type=script&lang=js"
import style0 from "./ContentMatrix.vue?vue&type=style&index=0&id=1b658c5c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports